(function () {
  const jdgmElements = document.querySelectorAll(
    ".jdgm-widget:not(.jdgm-all-reviews-text), .jdgm-all-reviews-page, .jdgm-carousel-wrapper, #judgeme_product_reviews"
  );

  if (jdgmElements.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // remove observer
            observer.disconnect();
            // execute jdgm assets
            const jdgmScript = document.getElementsByClassName("jdgm-script");
            if (jdgmScript.length > 0) {
              Function(jdgmScript[0].textContent)();
              window.TitusObjectObserver.observeCustom(() => {
                return document.querySelector(
                  "section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup"
                );
              })
                .catch(() => {})
                .finally(() => {
                  jdgmElements.forEach((jdgmElement) => {
                    window.removeLoader(jdgmElement);
                  });
                });
            }
          }
        });
      },
      {
        rootMargin:
          window.screen && window.screen.availWidth > 600 ? "250px" : "500px",
      }
    );

    jdgmElements.forEach((jdgmElement) => {
      // add intersection observer to jdgmElement
      // exclude jdgm-preview-badge, we're handling this differently - see below
      if (!jdgmElement.classList.contains("jdgm-preview-badge")) {
        observer.observe(jdgmElement);
        // add loader
        window.generateLoader(jdgmElement);
      }
      // handle jdgm-preview-badge that does not show review count text without the jdgm app
      if (jdgmElement.classList.contains("jdgm-preview-badge")) {
        if (!jdgmElement.querySelector(".jdgm-prev-badge")) return;
        const count =
          jdgmElement.querySelector(".jdgm-prev-badge").dataset.numberOfReviews;
        const countEl = jdgmElement.querySelector(".jdgm-prev-badge__text");
        if (jdgmSettings.badge_hide_text || !countEl) return;
        if (count) {
          let text = jdgmSettings.badge_n_reviews_text;
          const split = text.split("{{ n }} ");
          split.forEach((item, index) => {
            if (count == 1) {
              split[index] = item.split("/")[0];
            } else {
              split[index] = item.split("/")[1];
            }
          });
          text = split.join("{{ n }} ").replace("{{ n }}", count);
          countEl.textContent = text;
        } else {
          countEl.textContent = jdgmSettings.badge_no_review_text;
        }
        countEl.style.visibility = "visible";
      }
      // add product images to product reviews widget
      const addProductImages = () => {
        const elements = jdgmElement.querySelectorAll('.jdgm-rev[data-product-url]');
        if (elements.length > 0) {
          elements.forEach((element) => {
            const productUrl = element.dataset.productUrl;
            const productTitle = element.dataset.productTitle;
            const titleHandle = productTitle.split(' ').join('-').toLowerCase();
            const colorHandle = productUrl.split(titleHandle)[1];
            let variantPickerLink = document.querySelector('a.opt-label--image[href*="' + colorHandle + '"]');
            if (!variantPickerLink) {
              variantPickerLink = document.querySelector('a.opt-label--image');
            }
            const img = variantPickerLink.querySelector('img');
            if (img) {
              const imgSrc = img.getAttribute('src');
              const imgAlt = img.getAttribute('alt');
              const imgElement = document.createElement('img');
              imgElement.setAttribute('src', imgSrc);
              imgElement.setAttribute('alt', imgAlt);
              imgElement.classList.add('jdgm-product-image');
              const innerHTML = element.innerHTML;
              const newHtml = '<div style="margin-right: 12px; width: 87px; flex: none;">' + imgElement.outerHTML + '</div><div class="flex-auto">' + innerHTML + '</div>';
              element.innerHTML = newHtml;
              element.classList.add('flex', 'items-center');
            }
          });
        }
      }
      if (jdgmElement.id === 'judgeme_product_reviews') {
        addProductImages();

        // mutation observer on .jdgm-rev-widg__body
        const targetNode = jdgmElement.querySelector('.jdgm-rev-widg__body');
        const config = { attributes: false, childList: true, subtree: false };
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            addProductImages();
          }
        });
        observer.observe(targetNode, config);
      }
    });
  }

  // Fix for Judge.me reviews scroll to reviews with sticky header
  const reviewContainerSelector = ".template-product #judgeme_product_reviews";
  const reviewStarsSelector = ".product-info__block .jdgm-preview-badge";
  const mainMenuSelector = ".template-product .main-menu__disclosure";
  const reviewStars = document.querySelector(reviewStarsSelector);
  const reviewContainer = document.querySelector(reviewContainerSelector);
  const mainMenu = document.querySelector(mainMenuSelector);

  if (reviewStars && reviewContainer && mainMenu) {
    const parentElement = reviewStars.parentElement;
    reviewContainer.querySelector('.jdgm-rev-widg > .jdgm-temp-hiding-style').remove();

    reviewStars.style.pointerEvents = "none";
    parentElement.style.cursor = "pointer";

    const listener = () => {
      let headerHeight = parseInt(getComputedStyle(document.querySelector('store-header')).getPropertyValue("--menu-height") || "0");
      let bodyHeight = document.body.clientHeight;
      let windowHeight = window.innerHeight;
      if (windowHeight < headerHeight) {
        headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height") || "0");
      }
      let reviewContainerPosition = reviewContainer.getBoundingClientRect().top;
      let calculatedScrollToPosition = reviewContainerPosition - headerHeight;

      if ((calculatedScrollToPosition + windowHeight) > bodyHeight) {
        document.body.style.setProperty('--jdgm-height-fix', `${calculatedScrollToPosition + windowHeight - bodyHeight}px`);
      }

      window.scrollBy({
        top: calculatedScrollToPosition,
        behavior: "smooth",
      });
    }

    parentElement.addEventListener("click", async () => {
      // check what lazy elements come before the reviews
      const mainContentEl = document.querySelector("#main-content");
      const childrenArr = Array.from(mainContentEl.children);
      const recIndex = childrenArr.indexOf(document.querySelector('section:has(product-recommendations)'));
      const lastIndex = childrenArr.indexOf(document.querySelector('section:has(recently-viewed)'));
      const jdgmIndex = childrenArr.indexOf(document.querySelector('section:has(#judgeme_product_reviews)'));

      // unobserve lazy elements
      if (jdgmIndex > recIndex && recIndex !== -1) {
        prodRecEl = document.querySelector('product-recommendations');
        prodRecEl.unobserve();
      }

      if (jdgmIndex > lastIndex && lastIndex !== -1) {
        recViewEl = document.querySelector('recently-viewed');
        recViewEl.unobserve();
      }

      // scroll to reviews
      listener();

      if (!document.querySelector("section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup")) {
        // init lazy elements after scroll, which otherwise can mess with the scroll distance
        // we need to wait for the scroll to finish and use jdgm--done-setup-widget as a trigger because it's unlikely jdgm initializes before the scroll finishes
        window.TitusObjectObserver.observeCustom(() => {
          return document.querySelector(
            "section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup"
          );
        })
          .catch(() => {})
          .finally(() => {
            prodRecEl.init();
            recViewEl.init();
          });
      }
    });
  }
})();
